import { Box, Button, Typography } from "@mui/material";
import { ArrowLeft, Eye } from "@phosphor-icons/react";
import {
  formatDateToDDMMYYYY,
  formatDateToYYYYMM,
} from "../../../globals/utils";
import { StyledInvoicePage } from "./invoice.styled";
import { useNavigate, useParams } from "react-router-dom";
import { useInvoice } from "../../../stores/useInvoice";
import { useProfile } from "../../../stores/useProfile";
import { useContext, useEffect, useMemo, useState } from "react";
import { LanguageContext } from "../../../globals/LanguageContext";
import { Invoice } from "../../../models/Invoice";
import { PdfViewer } from "../../../components/pdfViewer/pdfViewer";
// import { PdfViewer } from "../../../components/pdfViewer/pdfViewer";

export const InvoicePage = () => {
  const { id } = useParams();
  const { fetchInvoice } = useInvoice();
  const { user } = useProfile();
  const { dictionary } = useContext(LanguageContext);
  const navigate = useNavigate();
  const [invoice, setInvoice] = useState<Invoice | undefined>();
  const [numPages, setNumPages] = useState<number>();
  const [pageNumber, setPageNumber] = useState<number>(1);

  useEffect(() => {
    if (!user || !id) return;
    fetchInvoice(user, Number(id)).then((res) => {
      setInvoice(res);
    });

    // if (!project) {
    //   navigate(`/projects`);
    // }
  }, [id]);

  return (
    <StyledInvoicePage>
      <Box className="header">
        <Button
          variant="outlined"
          className="backbtn"
          onClick={() => navigate(`/invoices`)}
        >
          <ArrowLeft size={32} weight="bold" />
          {dictionary.buttons.gobackbtn}
        </Button>
        <Typography variant="h1">{invoice?.name}</Typography>
      </Box>
      <Box className="content">
        <Box className="infoWrapper">
          <Box className="info">
            <Box className="row">
              <Box className="column">
                <Typography variant="h3" className="text">
                  Factuurdatum
                </Typography>
                <Typography variant="h3">
                  {invoice?.invoiceDate &&
                    formatDateToDDMMYYYY(invoice?.invoiceDate)}
                </Typography>
              </Box>
              <Box className="column">
                <Typography variant="h3" className="text">
                  Betaaldatum
                </Typography>
                <Typography variant="h3">
                  {invoice?.invoiceDate
                    ? formatDateToDDMMYYYY(invoice?.paymentDate as Date)
                    : "--/--/----"}
                </Typography>
              </Box>
            </Box>
            <Box className="row">
              <Box className="column">
                <Typography variant="h3" className="text">
                  Beschrijving
                </Typography>
                <Typography variant="h3">{invoice?.description}</Typography>
              </Box>
              <Box className="column">
                <Typography variant="h3" className="text">
                  Type
                </Typography>
                <Typography variant="h3">{invoice?.type}</Typography>
              </Box>
            </Box>
            <Box className="row">
              <Box className="column">
                <Typography variant="h3" className="text">
                  Project
                </Typography>
                <Typography variant="h3">
                  PRO-
                  {formatDateToYYYYMM(
                    new Date(invoice?.project?.creationDate as Date)
                  )}
                  -{invoice?.project?.code}
                </Typography>
              </Box>
              <Box className="column">
                <Typography variant="h3" className="text">
                  Kwartaal
                </Typography>
                <Typography variant="h3">{invoice?.quarter}</Typography>
              </Box>
            </Box>
            <Box className="row">
              <Box className="column">
                <Typography variant="h3" className="text">
                  Bedrag
                </Typography>
                <Typography variant="h3">{invoice?.priceExVat}</Typography>
              </Box>
              <Box className="column">
                <Typography variant="h3" className="text">
                  BTW
                </Typography>
                <Typography variant="h3">{invoice?.vat}</Typography>
              </Box>
              <Box className="column">
                <Typography variant="h3" className="text">
                  Totaal
                </Typography>
                <Typography variant="h3">{invoice?.totalAmount}</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box className="file">
          {invoice?.file && <PdfViewer file={invoice?.file} />}
        </Box>
      </Box>
    </StyledInvoicePage>
  );
};
